import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {navigateStore} from "@services/navigateObserver/navigate.store";

export const NavigateObserver = () => {

    const navigate = useNavigate();

    useEffect(() => {
        navigateStore.setNavigate(navigate);
    }, [navigate]);

    return null
}